import { render, staticRenderFns } from "./BotaoPersonalizado.vue?vue&type=template&id=6edc438b&scoped=true&"
import script from "./BotaoPersonalizado.vue?vue&type=script&lang=js&"
export * from "./BotaoPersonalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc438b",
  null
  
)

export default component.exports